module.exports = __webpack_public_path__ + "img/identity-logo.63cb817c.png";